import type { TenantAccess } from "@broadview/api-client";

export function automaticallySelectedDivision(
  tenants: readonly TenantAccess[],
): TenantAccess | null {
  return tenants.length === 1 ? (tenants[0] ?? null) : null;
}
